import { Box, Card, CardContent, CardMedia, Grid, Typography } from '@mui/material';
import ReusableHeadingComponents from '../../components/reusableComponents/reusableHeadingComponents';
import ReusableBtn from '../../components/reusableComponents/ReusableBtn';
import ReusableMuiIcons from '../../_helpers/ReusableMuiIcons';
import ReusableChip from '../../components/reusableComponents/chipSelector';
import ReusableButton from '../../components/reusableComponents/reusableButtonComponents';
import { useHistory, useParams } from "react-router-dom";
import { text } from 'd3';
import { Avatar } from '@mui/material';

export default function ViewGuidelinesFaq({ offerDetail }) {
  const { offerId } = useParams();
  const history = useHistory();
  const messagingGuidelines = [
    offerDetail?.guidelines
  ];

  const deliverableDetails = [
    ...(offerDetail?.content_review ? [{ title: "Content Review", content: 'Before Posting the content*' }] : []),
    ...(offerDetail?.hashtags ? [{ title: "Hashtags & Mentions", content: offerDetail.hashtags }] : []),
    ...(offerDetail?.mentions ? [{ title: "Mandatory Mentions", content: offerDetail.mentions }] : [])
  ];

  const renderChips = (content, isSingleChip = false) => {
    if (!content) return null;

    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    // 🔹 Remove <p>, <ul>, <ol>, <li> but keep their inner text
    ["p", "ul", "ol", "li"].forEach(tag => {
      const elements = doc.querySelectorAll(tag);
      elements.forEach(el => {
        const parent = el.parentNode;
        while (el.firstChild) {
          parent.insertBefore(el.firstChild, el);
        }
        parent.removeChild(el);
      });
    });

    const textHTML = doc.body.innerHTML.trim() || "";

    if (isSingleChip) {
      return (
        <ReusableChip
          bgcolor="#E8E8E8"
          color="#7A7A7A"
          borderRadius="4px"
          sx={{ p: '15px 12px' }}
          label={<span dangerouslySetInnerHTML={{ __html: textHTML }} />}
        />
      );
    }

    const words = textHTML.split(/\s+/).filter(word => word.trim() !== "");
    return words.map((word, i) => (
      <ReusableChip
        key={i}
        bgcolor="#E8E8E8"
        color="#7A7A7A"
        borderRadius="4px"
        sx={{ p: '15px 12px' }}
        label={<span dangerouslySetInnerHTML={{ __html: word }} />}
      />
    ));
  };

  const sectionTitle = { fontSize: 18, fontWeight: 600, color: '#7A7A7A' };

  // const handleEdit = () => {
  //   history.push(`/edit-offer/guidelines/${offerId}`);
  // };

  const renderListWithIcon = (html, iconName, iconColor) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html || '', "text/html");
    const items = Array.from(doc.querySelectorAll("li")).filter(li => li.innerHTML.trim() !== '');

    if (items.length === 0) {
      const textHTML = doc.body.innerHTML?.trim();
      if (!textHTML) return null;

      return (
        <Box display="flex" gap={1} alignItems="flex-start" mb={1}>
          <ReusableMuiIcons name={iconName} sx={{ color: iconColor, mt: '4px' }} />
          <Typography
            sx={guidelineText}
            component="div"
            dangerouslySetInnerHTML={{ __html: textHTML }}
          />
        </Box>
      );
    }

    return items.map((li, index) => (
      <Box key={index} display="flex" gap={1} alignItems="flex-start" mb={1}>
        <ReusableMuiIcons name={iconName} sx={{ color: iconColor, mt: '4px' }} />
        <Typography
          sx={guidelineText}
          component="div"
          dangerouslySetInnerHTML={{ __html: li.innerHTML }}
        />
      </Box>
    ));
  };


  const extractPlainTextFromHTML = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html || '', "text/html");
    const text = doc.body.textContent || "";
    return text.trim();
  };

  return (
    <Box sx={{ p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems={{ xs: 'flex-start', md: 'center' }} flexDirection={{ xs: 'column', md: 'row' }} >
        <ReusableHeadingComponents heading="Content Guidelines" />
        {/* <ReusableBtn label="edit" icon={<ReusableMuiIcons name="edit" />} onClick={handleEdit} disabled={offerDetail?.is_draft === false}/> */}
      </Box>

      <Grid container spacing={2}>
        {/* Left */}
        <Grid item xs={12} md={8}>
          <Card sx={cardStyle}>
            <Typography sx={sectionTitle}>Reference Links</Typography>
            <Box sx={borderBox('#A454ED')}>
              <Typography sx={{ fontSize: 16, fontWeight: 600, color: '#7A7A7A' }}>Moodboard Reference</Typography>
              <Box display="flex" flexWrap={"wrap"} flexDirection={{ xs: 'column', md: 'row' }} gap={2} pt={2}>
                {offerDetail?.reference_links?.map((item, i) => (
                  <a href={item.link} key={i} target="_blank" rel="noopener noreferrer">
                    <ReusableButton variant="contained"
                      //  children={item.link}
                      children={item.link.length > 20 ? item.link.slice(0, 20) + '...' : item.link}
                      endIcon={<ReusableMuiIcons name="open" />} classNames="gn-actionbtn" sx={{ textTransform: 'none' }} />
                  </a>
                ))}
              </Box>
            </Box>
          </Card>

          <Card sx={{ ...cardStyle, mt: 3 }}>
            <Typography sx={sectionTitle}>Target Audience</Typography>
            {deliverableDetails.map((detail, i) => (
              <Box key={i} mb={2}>
                <Typography sx={{ fontSize: 16, fontWeight: 500, color: '#7A7A7A', mb: 1 }}>{detail.title}</Typography>
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {renderChips(detail.content, detail.title === "Content Review")}
                </Box>
              </Box>
            ))}
          </Card>

          {offerDetail?.faq?.trim() && (
            <Card sx={{ mt: 3, borderRadius: 2 }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h6" sx={sectionTitle}>FAQ</Typography>
                <Typography sx={{ fontSize: 16, fontWeight: 500, color: '#7A7A7A', mt: 2 }} dangerouslySetInnerHTML={{
                  __html: offerDetail?.faq
                }} />
              </CardContent>
            </Card>
          )}
        </Grid>

        {/* Right */}
        <Grid item xs={12} md={4}>
          <Card sx={rightCardStyle}>
            <Typography sx={{ ...sectionTitle, mb: 3 }}>Brand Contact Info</Typography>
            <Box textAlign="center" mb={2}>
              <Avatar
                sx={{
                  width: 58,
                  height: 58,
                  margin: '0 auto',
                  border: '1px solid #B8B8B8',
                  color: '#A6A6A6',
                  fontSize: 20,
                  fontWeight: 700,
                  backgroundColor: '#fff !important',
                  marginBottom: '4px'
                }}
              >
                {offerDetail?.contact_name?.charAt(0)?.toUpperCase() || '-'}
              </Avatar>
              <Typography sx={contactName}>{offerDetail?.contact_name}</Typography>
              <Typography sx={contactInfo}>{offerDetail?.designation}</Typography>
            </Box>
            <Box>
              <InfoLabel label="Email" value={offerDetail?.email} />
              <InfoLabel label="Phone/WhatsApp" value={offerDetail?.phone} />
            </Box>
            <Box display="flex" justifyContent="space-between">
              <a href={`https://wa.me/${offerDetail?.phone}`} target="_blank" rel="noopener noreferrer">
                <ReusableButton children="Whatsapp" variant="contained" classNames="gn-actionbtn" sx={whatsappBtn} />
              </a>
              <a href={`mailto:${offerDetail?.email}`} target="_blank" rel="noopener noreferrer">
                <ReusableButton children="Email" variant="outlined" classNames="gn-actionbtn-outline gn-actionbtn-color" sx={emailBtn} />
              </a>
            </Box>
          </Card>

          <Card sx={{ ...rightCardStyle, mt: 3 }}>
            <Box sx={borderBox('#219653')}>
              <Typography sx={sectionTitle}>Do's</Typography>
              {/* <Typography sx={guidelineText} ><ReusableMuiIcons name="tick" sx={{ color: '#219653' }}  />
              <Box dangerouslySetInnerHTML={{ __html: offerDetail?.content_do || '' }}/> 
               </Typography> */}
              {renderListWithIcon(offerDetail?.content_do, "tick", "#219653")}
            </Box>
            <Box sx={borderBox('#F14950')}>
              <Typography sx={sectionTitle}>Don'ts</Typography>
              {renderListWithIcon(offerDetail?.content_do, "cancel", '#F14950')}
            </Box>
            <Box sx={borderBox('#7A7A7A')}>
              <Typography sx={sectionTitle}>Messaging Guidelines</Typography>
              {offerDetail?.guidelines && Array.isArray(messagingGuidelines) && messagingGuidelines.map((msg, i) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(msg || '', "text/html");
                const liItems = Array.from(doc.querySelectorAll("li")).filter(li => li.textContent.trim() !== '');

                return (
                  <Box key={i} component="ul" sx={{ pl: 2, m: 0 }}>
                    {liItems.length > 0 ? (
                      liItems.map((li, idx) => (
                        <Box key={idx} component="li">
                          <Typography sx={guidelineText} component="div" dangerouslySetInnerHTML={{ __html: li.innerHTML }}></Typography>
                        </Box>
                      ))
                    ) : (
                      extractPlainTextFromHTML(msg) && (
                        <Box component="li">
                          <Typography sx={guidelineText} component="div" dangerouslySetInnerHTML={{ __html: msg }}></Typography>
                        </Box>
                      )
                    )}
                  </Box>
                );
              })}
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

const cardStyle = {
  p: '18px 20px',
  backgroundColor: '#FFF',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  borderRadius: 2,
};

const rightCardStyle = {
  p: 3,
  borderRadius: 2,
  backgroundColor: '#FFF',
};

const contactName = { fontSize: 20, fontWeight: 700, color: '#797979', mb: 1 };
const contactInfo = { fontSize: 16, fontWeight: 400, color: '#797979', mb: 2 };

const guidelineText = {
  fontSize: 16,
  fontWeight: 400,
  color: '#7A7A7A',
  pb: '2px',
  wordBreak: 'break-word'
};

const whatsappBtn = {
  p: { xs: '7px 30px !important', md: '7px 50px !important' },
  backgroundColor: '#219653 !important',
  border: 'none !important',
};

const emailBtn = {
  p: { xs: '7px 40px !important', md: '7px 50px !important' },
  color: '#7A7A7A !important',
  backgroundColor: '#FFF !important',
  border: '1px solid #797979 !important',
};

const borderBox = (color) => ({
  border: `0.5px solid ${color}`,
  borderRadius: 1,
  p: 2,
  mb: 2,
});

const InfoLabel = ({ label, value }) => (
  <>
    <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#797979' }}>{label}</Typography>
    <Typography sx={{ fontSize: 14, fontWeight: 400, color: '#797979', mb: 2 }}>{value}</Typography>
  </>
);
